import { configureStore } from '@reduxjs/toolkit';

import systemSlice from './system/slice';

export const store = configureStore({
    reducer: {
        system: systemSlice.reducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
        })
});
